import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class PredicateValidator {

    static conditionalValidator(
        predicate: { (): boolean },
        validator: ValidatorFn,
        errorNamespace?: string,
    ): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.parent) {
                return null;
            }

            let error: ValidationErrors | null = null;

            if (predicate()) {
                error = validator(control);
            }

            if (errorNamespace && error) {
                const customError = {};
                customError[errorNamespace] = error;
                error = customError;
            }
            return error;
        };
    }
}


